export default "__VITE_ASSET__2ef55dd3__"